/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";#congratulations[_ngcontent-%COMP%]   .student-name[_ngcontent-%COMP%], #congratulations[_ngcontent-%COMP%]   .student-picture[_ngcontent-%COMP%]{float:left;font:24px/28px PoppinsThin}#congratulations[_ngcontent-%COMP%]   .student-name[_ngcontent-%COMP%]{padding-top:6px}"];
export { styles as styles };
//# sourceMappingURL=mid-level-exam-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/learning/mid-level-exam-modal/mid-level-exam-modal.component.scss.shim.ngstyle.js
// module id = 1366
// module chunks = 27 28 29